/* eslint-disable react/no-multi-comp */
import React from "react"
import TechSpecsComponent from "./TechSpecs"
import TechSpecsListComponent from "./TechSpecsList"
import techSpecsFactory from "./techSpecs.factory"

export { default as TechSpecsQuery } from "./techSpecs.query"

export const TechSpecs = props => {
  const { data } = props
  const componentProps = { ...props, ...techSpecsFactory.transform(data) }
  return <TechSpecsComponent {...componentProps} />
}

export const TechSpecsList = props => {
  const { data } = props
  const listComponentProps = { ...props, ...techSpecsFactory.transformList(data) }
  return <TechSpecsListComponent {...listComponentProps} />
}
